import { EmailHasNotSubfoldersBaseValueConverter } from 'General/Resources/ValueConverters/EmailHasNotSubfoldersBase';

export class EmailHasNotSubfoldersValueConverter extends EmailHasNotSubfoldersBaseValueConverter {
}